import { observer } from "mobx-react";
import Selfie from "./index";

const SelfieOnly = observer(() => {
    return <Selfie processType="selfieOnly" />;
})

export default SelfieOnly;